import { formatISOString } from 'src/utilities/time-utils';

const INSIGHTS_DATA_LAST_UPDATED_FORMAT = 'MMMM d, h:mm a';

export function formatInsightsDataLastUpdated(
  dataLastUpdated?: string
): string | null {
  if (!dataLastUpdated) {
    return null;
  }

  return formatISOString(dataLastUpdated, INSIGHTS_DATA_LAST_UPDATED_FORMAT);
}
